
/* ============================================================
 * Footer : scenographie magique
 * 1. entree au scroll : la nuit s'allume (voile qui se dissipe)
 *    et la signature, la tagline et les colonnes se revelent en cascade
 * 2. lucioles dorees qui errent dans les fleurs
 * 3. lueur de lune au curseur + trainee de poussiere d'etoiles
 * 4. eclat de particules quand on atteint le bas de la page
 * ============================================================ */
(function(){
  var foot=document.querySelector('.s-foot'); if(!foot) return;
  var RED=matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* --- 1. entree scenographiee : parallax doux + la nuit s'allume + cascade --- */
  var dim=foot.querySelector('.f-dim');
  var bg=foot.querySelector('.f-bg');
  if(!RED && typeof gsap!=='undefined' && typeof ScrollTrigger!=='undefined'){
    var scrubv=window.__lenis?true:.45;
    /* le fond glisse plus lentement que la page */
    gsap.fromTo(bg,{y:'-11%'},{y:'0%',ease:'none',
      scrollTrigger:{trigger:foot,start:'top bottom',end:'bottom bottom',scrub:scrubv,invalidateOnRefresh:true}});
    /* la nuit s'allume */
    if(dim) gsap.fromTo(dim,{opacity:.5},{opacity:0,ease:'none',
      scrollTrigger:{trigger:foot,start:'top 88%',end:'top 20%',scrub:scrubv,invalidateOnRefresh:true}});
    /* cascade du contenu */
    var items=foot.querySelectorAll('.f-eyebrow,.flogo-big,.f-tag,.f-social,.f-cols > div,.s-foot-bottom');
    gsap.set(items,{opacity:0,y:26});
    var tl=gsap.timeline({scrollTrigger:{trigger:foot,start:'top 88%',end:'bottom bottom',scrub:scrubv,invalidateOnRefresh:true}});
    tl.to(items,{opacity:1,y:0,ease:'power2.out',stagger:.07,duration:.5},.18);
  } else if(dim){ dim.style.opacity=0; }
  if(RED) return;

  /* --- 2/3/4. canvas magie --- */
  var wrap=foot.querySelector('.f-fx'); if(!wrap||!window.requestAnimationFrame) return;
  var cv=document.createElement('canvas'); wrap.appendChild(cv);
  var ctx=cv.getContext('2d');
  var W=0,H=0;
  function resize(){
    var r=wrap.getBoundingClientRect(); if(r.width<2) return;
    var dpr=Math.min(devicePixelRatio||1,2);
    W=r.width;H=r.height;
    cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  addEventListener('resize',resize,{passive:true});
  resize();

  function dotSprite(tint){
    var c=document.createElement('canvas');c.width=c.height=64;
    var x=c.getContext('2d');
    var g=x.createRadialGradient(32,32,0,32,32,32);
    g.addColorStop(0,'rgba(255,255,255,1)');
    g.addColorStop(.22,'rgba('+tint+',.9)');
    g.addColorStop(.55,'rgba('+tint+',.22)');
    g.addColorStop(1,'rgba('+tint+',0)');
    x.fillStyle=g;x.fillRect(0,0,64,64);
    return c;
  }
  var GOLD=dotSprite('255,214,140'), BLUE=dotSprite('170,200,255');

  /* lucioles : errance organique dans la moitie basse */
  var flies=[];
  var NF=innerWidth<=760?8:14;
  for(var i=0;i<NF;i++){
    flies.push({x:Math.random(),y:.5+Math.random()*.46,a:Math.random()*6.283,
      turn:(Math.random()*.9+.4)*(Math.random()<.5?-1:1),
      sp:.000045+Math.random()*.00006,ph:Math.random()*6.283,
      s:7+Math.random()*9,tw:.7+Math.random()*1.5});
  }

  /* particules : poussiere du curseur + eclats */
  var parts=[];
  function spawn(x,y,n,up){
    for(var j=0;j<n;j++){
      if(parts.length>110) parts.shift();
      parts.push({
        x:x+(Math.random()-.5)*(up?160:14), y:y+(Math.random()-.5)*10,
        vx:(Math.random()-.5)*(up?.05:.03), vy:up?(-.05-Math.random()*.1):(-.015-Math.random()*.03),
        life:1, dec:up?(.00045+Math.random()*.00045):(.0011+Math.random()*.0009),
        s:up?(5+Math.random()*8):(3+Math.random()*4.5),
        g:Math.random()<.82});
    }
  }

  /* le halo et la trainee au curseur sont desormais geres par la couche magique globale */

  /* eclat d'arrivee en bas de page */
  var lastBurst=0;
  function burst(){
    var now=Date.now(); if(now-lastBurst<16000) return;
    lastBurst=now; spawn(W*.5,H*.76,26,true);
  }
  var sent=document.createElement('div');
  sent.style.cssText='position:absolute;bottom:0;left:0;height:2px;width:100%;pointer-events:none;';
  foot.appendChild(sent);
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ if(es[0].isIntersecting) burst(); }).observe(sent);
  }

  /* boucle */
  var running=false,visible=false,raf=0,last=0;
  function loop(ms){
    if(!running) return;
    raf=requestAnimationFrame(loop);
    if(ms-last<24) return;
    var dt=Math.min(ms-last,80); last=ms;
    var t=ms/1000;
    ctx.clearRect(0,0,W,H);
    ctx.globalCompositeOperation='lighter';

    /* lucioles */
    for(var i=0;i<flies.length;i++){
      var f=flies[i];
      f.a+=Math.sin(t*f.turn+f.ph)*.018*dt*.06;
      f.x+=Math.cos(f.a)*f.sp*dt; f.y+=Math.sin(f.a)*f.sp*dt*.55;
      if(f.x<-.02)f.x=1.02; if(f.x>1.02)f.x=-.02;
      if(f.y<.42)f.y=.42+(.42-f.y); if(f.y>1)f.y=1-(f.y-1)-.001;
      var al=.3+.3*Math.sin(t*f.tw+f.ph);
      if(al<=0.02) continue;
      ctx.globalAlpha=al;
      ctx.drawImage(GOLD,f.x*W-f.s,f.y*H-f.s,f.s*2,f.s*2);
    }

    /* poussiere d'etoiles */
    for(var k=parts.length-1;k>=0;k--){
      var p=parts[k];
      p.x+=p.vx*dt; p.y+=p.vy*dt; p.life-=p.dec*dt;
      if(p.life<=0){ parts.splice(k,1); continue; }
      ctx.globalAlpha=Math.max(0,Math.min(1,p.life))*.9;
      var sz=p.s*(.4+.6*p.life);
      ctx.drawImage(p.g?GOLD:BLUE,p.x-sz,p.y-sz,sz*2,sz*2);
    }
    ctx.globalAlpha=1;ctx.globalCompositeOperation='source-over';
  }
  function start(){ if(running) return; running=true; last=performance.now(); raf=requestAnimationFrame(loop); }
  function stop(){ running=false; cancelAnimationFrame(raf); }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      visible=es[0].isIntersecting;
      if(visible) start(); else stop();
    },{rootMargin:'100px'}).observe(wrap);
  }else{ start(); }
  document.addEventListener('visibilitychange',function(){ if(document.hidden) stop(); else if(visible) start(); });
})();
